import type { Session } from '@supabase/supabase-js'
import { create } from 'zustand'

type AuthState = {
  /** Supabase のセッション。null ならサインアウト状態 */
  session: Session | null
  /** 起動時のセッション復元が終わったか */
  isLoaded: boolean
  setSession: (session: Session | null) => void
}

export const useAuthStore = create<AuthState>()((set) => ({
  session: null,
  isLoaded: false,
  setSession: (session) => set({ session, isLoaded: true }),
}))

export const useIsSignedIn = (): boolean => useAuthStore((state) => state.session !== null)

/** トークン更新のたびに session は作り直されるので、ユーザーが変わったかはこの ID で判断する */
export const useAuthUserId = (): string | null => useAuthStore((state) => state.session?.user.id ?? null)
